import PropTypes from 'prop-types';
import { Row, Col, FormGroup, Stack, Input, CheckBox } from 'components/ui';
import { PersonData } from 'components/impfschaeden/assistent/VaxForm_04_InfoZurPerson/components/PersonData.js';
import { Location } from 'components/impfschaeden/assistent/VaxForm_04_InfoZurPerson/components/Location.js';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const InfosZurPerson = ({ anotherPerson, formData, update, validation }) => {
	const [t] = useTranslation();
	const user = useSelector((state) => state.settings.currentUser);
	if (user?.is_moderator) {
		anotherPerson = true;
	}

	return (
		<>
			{anotherPerson && (
				<Row xs={12} style={{ marginTop: '0px' }}>
					<Col xs={12} md={6}>
						<FormGroup className='mb-3'>
							<Stack gap={3}>
								<Input
									type='text'
									label={t('nutzerbereich.registrieren.vorname') + ' *'}
									value={formData.first_name || ''}
									onChange={(e) => {
										const visible = e.target.value == 'Unbekannt' ? 0 : 1;
										update({
											first_name: e.target.value,
											visible_first_name: visible,
										});
									}}
									isInvalid={validation['first_name']}
									name='person_info_first_name'
									id='person_info_first_name_id'
								/>
								<Input
									type='text'
									label={
										t('nutzerbereich.registrieren.nachname_oder_kuerzel') + ' *'
									}
									value={formData.last_name || ''}
									onChange={(e) => {
										const visible = e.target.value == 'Unbekannt' ? 0 : 1;
										update({
											last_name: e.target.value,
											visible_last_name: visible,
										});
									}}
									isInvalid={validation['last_name']}
									name='formData_last_name'
									id='formData_last_name_id'
								/>
							</Stack>
						</FormGroup>
						<PersonData
							update={update}
							formData={formData}
							validation={validation}
						/>
					</Col>
					<Col xs={12} md={6}>
						<Location
							update={update}
							formData={formData}
							validation={validation}
						/>
						{user && (
							<CheckBox
								label={t('impfschaden.erfassen.promi')}
								onChange={() => {
									update({
										promi: !formData.promi,
										groups: [],
										visible_first_name: 1,
										visible_last_name: 1,
										visible_city: 1,
										visible_avatar: 1,
									});
								}}
								checked={formData.promi}
							/>
						)}
					</Col>
				</Row>
			)}
			{!anotherPerson && (
				<Row xs={12} style={{ marginTop: '0px' }}>
					<Col xs={12} md={6}>
						<Location
							update={update}
							formData={formData}
							validation={validation}
						/>
					</Col>
					<Col xs={12} md={6} style={{ marginTop: '48px' }}>
						<PersonData
							update={update}
							formData={formData}
							validation={validation}
						/>
					</Col>
				</Row>
			)}
		</>
	);
};

InfosZurPerson.propTypes = {
	anotherPerson: PropTypes.bool,
	formData: PropTypes.object,
	update: PropTypes.func,
	validation: PropTypes.object,
};

export { InfosZurPerson };
